import { set, get } from "./Local";
import {Al} from "../helpers/async.helper";
import axios from "axios";

const addImage = (imageAsBase64) => {
    set('image', imageAsBase64);
};

const addName = (name) => {
    set('dealerName', name);
};

const getImage = () => {
    return get('image');
}

const getCulture = () => {
    const culture = get('culture');
    return culture ?? 'de-DE';
}

const setCulture = (culture) => {
    set('culture', culture);
}

const getCurrency = () => {
    const culture = get('currency');
    return culture ?? 'EUR';
}

const setCurrency = (culture) => {
    set('currency', culture);
}

const addColor = (name) => {
    set('dealerColor', name);
};

const getColor = () => {
    return get('dealerColor');
}

const addHslH = (name) => {
    set('hslH', name);
};

const getHslH = () => {
    return get('hslH');
}

const addHslS = (name) => {
    set('hslS', name);
};

const getHslS = () => {
    return get('hslS');
}

const addHslL = (name) => {
    set('hslL', name);
};

const getHslL = () => {
    return get('hslL');
}

const setMerchantId = (id) => {
    return set('merchantId', id);
}

const getMerchantId = () => {
    return get('merchantId');
}


const getName = () => {
    return get('dealerName');
}

const init = async () => {
    const merchantId = getMerchantIdLive();
    setMerchantId(merchantId);
    await loadDealerData();

    document.body.style.setProperty('--secondary-color', getColor())
    document.body.style.setProperty('--secondary-color-h', getHslH())
    document.body.style.setProperty('--secondary-color-s', getHslS() + "%")
    document.body.style.setProperty('--secondary-color-l', getHslL() + "%")



    let found = null;
    let index = 0;
    document.styleSheets.forEach(s => {
        let i = 0;
            s.cssRules.forEach(r => {
                if(r.cssText.indexOf(' --secondary-color:') !== -1 && r.cssText.indexOf(':root') !== -1) {
                    found = s;
                    index = i;
                }
                ++i;
            });
        });
    if (found) {
        found.cssRules[index].style.setProperty('--secondary-color', getColor())
        found.cssRules[index].style.setProperty('--secondary-color-h', getHslH())
        found.cssRules[index].style.setProperty('--secondary-color-s', getHslS() + "%")
        found.cssRules[index].style.setProperty('--secondary-color-l', getHslL() + "%")
    }

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
    }


    if (getName() === 'Rollerspot') link.href = '/img/rollerspot_icon.png';
    else if (getName() === 'Sqooter') link.href = '/img/sqooter_icon.png';

    document.title = getName();
};

const loadDealerData = async () => {
    const result = await Al(axios.get(`${process.env.VUE_APP_API_BASEURL}/dealership`, {headers: {'X-Digitalino-Merchant': getMerchantId()}}));
    if (result.status === 200) {
        addImage(result.data.logo);
        addName(result.data.name);
        addColor(result.data.color);
        addHslH(result.data.hsl.h);
        addHslS(result.data.hsl.s);
        addHslL(result.data.hsl.l);
        setCulture(result.data.culture);
        setCurrency(result.data.currency);
    }
}


const getMerchantIdLive = () => {
    const completeUrl = location.href;
    let merchantId = completeUrl.split('.digitalino')[0].split('//')[1];
    if (merchantId.indexOf('localhost') !== -1) {
        merchantId = 'rollerspot';
    }
    return merchantId;
}

const getEmergencyNumber = () => {
    const name = getName();
    switch (name) {
        case 'Rollerspot': return '+49 173 3156371';
        case 'Sqooter': return '+43 72 521316';
        default: return '+41 44 558 57 58';
    }
}

export default {
    addImage,
    addName,
    getImage,
    getName,
    init,
    addColor,
    getColor,
    getMerchantId,
    getEmergencyNumber,
    getCulture,
    getCurrency
};
